import { useContext } from "react";

import { TApiButtonCommandFn } from ".";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { useDirectUpload } from "modules";

import { find, map } from "lodash-es";

export const useUploadDocuments = () => {
  const { form, inputs } = useContext(DynamicFormContext);
  const { uploadFile } = useDirectUpload();

  const uploadDocuments: TApiButtonCommandFn = async commandArgs => {
    const commandArgument = commandArgs?.[0];
    const fileInput = find(inputs, { key: commandArgument?.source });
    if (!fileInput) {
      return;
    }

    // Direct upload each file
    const signedBlobIds = await Promise.all(map(fileInput?.files, file => uploadFile(file)));

    // Set array of signedBlobId to input value for executeGroupApi
    form.onChange({
      target: { id: fileInput.id, value: signedBlobIds },
    });

    return signedBlobIds;
  };

  return uploadDocuments;
};
